import _ from 'lodash'

export default {
    filters: {
        translatedValue(valueObject, langCode) {
            if (_.get(valueObject, '_meta.translated', false)) {
                if (_.get(valueObject, `${langCode}.value`, false)) {
                    return _.get(valueObject, `${langCode}.value`)
                }
                if (_.get(valueObject, 'default.value', false)) {
                    return _.get(valueObject, 'default.value')
                }
            } else {
                return _.get(valueObject, 'value')
            }
            return undefined
        },
        translatedRawValue(valueObject, langCode) {
            if (_.get(valueObject, '_meta.translated', false)) {
                if (_.get(valueObject, `${langCode}.rawValue`, false)) {
                    return _.get(valueObject, `${langCode}.rawValue`)
                }
                if (_.get(valueObject, 'default.rawValue', false)) {
                    return _.get(valueObject, 'default.rawValue')
                }
            } else {
                return _.get(valueObject, 'value')
            }
            return undefined
        },
    },
}
